import type { Thunk } from 'types/redux'
import api from '@disco/api/server'
import {
  TAGS_LOAD_ERROR,
  TAGS_LOAD_SUCCESS,
} from '@disco/constants/ActionTypes'
/**
 * Loads all available tags from the server.
 * @returns Thunk that fetches tags and dispatches success or error actions
 */
export function loadTags(): Thunk {
  return async dispatch => {
    try {
      const tags = await api.getTags()
      dispatch({
        type: TAGS_LOAD_SUCCESS,
        tags,
      })
    } catch (error) {
      dispatch({
        type: TAGS_LOAD_ERROR,
        error,
      })
    }
  }
}
